import { Select, Spin, Input } from "antd";
// import { _ignoreBackspace } from "../../../services/Util";


const _ignoreBackspace = (e) => {
  if (e.key === "Backspace") {
    e.stopPropagation();
  }
};

export const selectOption = (currentData, previousData, label) => {
  let data = [...currentData];

  let arrayOfKey = currentData.map((obj) => obj.key);

  if (previousData && previousData !== currentData) {
    for (let value of previousData) {
      !arrayOfKey.includes(value.id.toString()) &&
        data.push(
          <Select.Option key={value.id} value={value.id}>
            {value[label]}
          </Select.Option>
        );
    }
  }
  return data;
};

export const LoadingOption = () => {
  return (
    <Select.Option key="loading">
      <Spin size="small" />
    </Select.Option>
  );
};

export const dropdownCustom = (menu, search, value, searchValue) => {
  return(
  <>
    <div style={{ padding: "2px 8px" }} 
        >
      <Input
        placeholder="Search"
        size="large"
        onChange={search}
        // allowClear
        value={value}
        defaultValue={value}
        onKeyDown={(e) => {
          _ignoreBackspace(e);
        }}
      />
    </div>
    <div style={{ padding: 2 }}>{menu}</div>
  </>
);}

export const OptionMultiple = (
  currentData,
  previousData,
  label,
) => {
  let data = [...currentData];
  let arrayOfKey = currentData.map((obj) => obj.key);
  if (previousData && previousData !== currentData) {
    for (let value of previousData) {
      !arrayOfKey.includes(value.id.toString()) &&
        data.push(
          <Select.Option key={value.id} value={value[label]}>
            <div style={{ display: "flex" }}>
              {value[label]}
              <span style={{ marginLeft: "auto", marginRight: "50px" }}>
                <input
                  value={value[label]}
                  type={"checkbox"}
                  style={{}}
                  disabled={value.false}
                  checked={value.checked}
                  onChange={()=>{}}
                />
              </span>
            </div>
          </Select.Option>
        );
    }
  }
  return data;
};

export const selectData = (currentData, previousData, label) => {
  let data = [currentData];

  let arrayOfKey = currentData.map((obj) => obj.key);

  if (previousData && previousData !== currentData) {
    for (let value of previousData) {
      !arrayOfKey.includes(value.id.toString()) &&
        data.push(
          <Select.Option key={value.id} value={value.id}>
            {value[label]}
          </Select.Option>
        );
    }
  }

  return data;
}
